import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Image, useInstrumentation } from '@resultadosdigitais/front-hub/react'
import { useTranslation } from 'react-i18next'
import { Brand } from '@resultadosdigitais/tangram-components'
import FormPassword from './FormPassword'
import LanguageDropdown from '../../LanguageDropdown'

import BackgroundIMGptBR from './assets/background-pt-BR.png'
import BackgroundIMGesES from './assets/background-es-ES.png'
import BackgroundIMGenUS from './assets/background-en-US.png'

const BgOverlay = styled(Image)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100% !important;
  height: 100vh !important;
  object-fit: cover;
  filter: blur(5px) brightness(0.6);

  @media screen and (max-width: 700px) {
    display: none;
  }
`

const StyledColumn = styled.div`
  position: fixed;
  overflow-y: scroll;
  top: 64px;
  right: 0;
  bottom: 0;
  left: 0;

  align-items: center;
  padding-top: var(--size-spacing-05);
  padding-bottom: var(--size-spacing-05);
  justify-content: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  > * + * {
    margin-top: var(--size-spacing-02);
  }
`

const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  font-family: var(--text-font-family);
  background-color: #fff;
  height: auto !important;
  @media screen and (max-width: 480px) {
    width: 90%;
  }
`

const Navbar = styled.header`
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: var(--color-white);
  box-shadow: var(--shadow-md);
  padding: var(--size-spacing-04);
  z-index: 1;
`

const Root = styled.div`
  height: 100%;
  background: var(--color-gray-10);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
`

const Box = styled.div`
  max-width: 800px;
  padding: var(--size-spacing-05);
  background: var(--color-white);
  border-radius: var(--border-radius-rounded);
  will-change: opacity, transform;
  > * + * {
    margin-top: var(--size-spacing-02);
  }
  @media screen and (max-width: 480px) {
    margin: 0 var(--size-spacing-04);
    padding: var(--size-spacing-02);
  }

  @media screen and (min-width: 600px) {
    min-width: 600px;
  }
`

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--size-spacing-06);
`

const SignupLogin = () => {
  const { i18n } = useTranslation()
  const locale = i18n.language
  const { track } = useInstrumentation()

  useEffect(() => {
    if (window.hj) {
      var hotjarTag = 'new_second_account_layout_v3_step2'
      window.hj('trigger', hotjarTag)
      window.hj('tagRecording', [hotjarTag])
      window.hj('event', [hotjarTag])
    }

    track('Signup: Create New Account Viewed')
  }, [track])

  const getBackgroundImg = () => {
    const locales = {
      'es-ES': BackgroundIMGesES,
      'en-US': BackgroundIMGenUS,
      'pt-BR': BackgroundIMGptBR,
    }

    return locales[locale] || BackgroundIMGptBR
  }

  return (
    <>
      <Navbar>
        <Brand kind={Brand.kinds.RDStationMarketing} titleId="brand" id="brand-rdsm" />
      </Navbar>
      <Root>
        <BgOverlay src={getBackgroundImg()} alt="" />
        <StyledColumn>
          <ContentContainer>
            <Box>
              <FormPassword />
              <StyledDiv>
                <LanguageDropdown />
              </StyledDiv>
            </Box>
          </ContentContainer>
        </StyledColumn>
      </Root>
    </>
  )
}

export default SignupLogin
